import {createAction} from 'redux-actions';

import {
  automaticExchange,
  automaticSell,
  systematics,
} from '../../../utils/api/api-endpoint-dictionary';
import callApi from '../../../utils/api/axios';

const DEFAULT_STATE = {
  isLoading: false,
  isLoaded: false,
  hasFailed: false,
  autoExchanges: {},
  autoSells: {},
  error: null,
};

/* Action Types */
export const DELETE_AUTO_SELL = 'DELETE_AUTO_SELL';
export const GET_AUTO_EXCHANGE = 'GET_AUTO_EXCHANGE';
export const GET_AUTO_SELL = 'GET_AUTO_SELL';

/* Reducers */
export default function userProductTypes(
  state = DEFAULT_STATE,
  { payload, type }
) {
  switch (type) {
    case `${GET_AUTO_SELL}_PENDING`:
      return {
        ...state,
        isLoaded: false,
        isLoading: true,
      };

    case `${GET_AUTO_SELL}_FULFILLED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        autoSells: payload.data,
      };

    case `${GET_AUTO_SELL}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        hasFailed: true,
        error: payload,
      };
    case `${GET_AUTO_EXCHANGE}_PENDING`:
      return {
        ...state,
        isLoaded: false,
        isLoading: true,
      };

    case `${GET_AUTO_EXCHANGE}_FULFILLED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        autoExchanges: payload.data,
      };

    case `${GET_AUTO_EXCHANGE}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        hasFailed: true,
        error: payload,
      };
    case `${DELETE_AUTO_SELL}_PENDING`:
      return {
        ...state,
        deleteLoaded: false,
        deleteLoading: true,
        deleteFailed: false,
      };
    case `${DELETE_AUTO_SELL}_REJECTED`:
      return {
        ...state,
        ...{ deleteLoading: false, deleteFailed: true },
      };
    case `${DELETE_AUTO_SELL}_FULFILLED`:
      return {
        ...state,
        deleteLoaded: true,
      };
    default:
      return state;
  }
}

/* Actions */
export const getExistingAutoExchange = () => {
  return (dispatch) => {
    const action = createAction(GET_AUTO_EXCHANGE)(callApi(automaticExchange));
    return dispatch(action);
  };
};

export const getExistingAutoSell = () => {
  return (dispatch) => {
    const action = createAction(GET_AUTO_SELL)(callApi(automaticSell));
    return dispatch(action);
  };
};

export const deleteAutoSell = (payload) => {
  return () =>
    createAction(DELETE_AUTO_SELL)(
      callApi(systematics, { method: 'POST' }, payload)
    );
};
